
import React from "react";
import { DashTitle, Action } from "../../funcs/utils";
import { Modal } from "../modal";
import {DEVICE_WIDTH} from "../../../lib/constants";

const render_header = (title) => {
  const style = {
    fontWeight: "bold",
  }
  return (<span style={style}>{title}</span>);
};

const PaymentsContainer2 = props => {

  const do_medium = props.device && props.device.width < DEVICE_WIDTH.medium;

  const divStyle = {
    background: "#FFF",
    padding: do_medium ? "0.5rem" : "2rem",
    margin: do_medium ? "0.5rem" : "2rem",
  };

  const header_style = {
    alignItems: "center",
  }
  if (!do_medium) {
    header_style.display = "flex";
  }

  return (
    <div style={divStyle}>
      <div style={header_style}>
        <div>
          <DashTitle
            device={props.device}
            client={props.client}
            title={props.title}
            header={props.suffix}
            style={{textAlign: "left", marginBottom: "1rem"}}
          />
          { /* props.suffix  */}
        </div>
        <div style={{flex: "1"}}>
          { props.header}
        </div>
      </div>
      <div>
        { props.children }
      </div>
    </div>
  )
};

// Deprecated. Use the one in helper.modals
const InfoDialog = props => {

  const div_style = {
    fontSize: "1.5rem",
  }

  return (
    <Modal
      container_style={{width: "40rem"}}
      show={true}
      onDismiss={props.onClose}
      onClose={props.onClose}
      noFooter={true}>
      <div align={"center"} style={div_style}>
        <span>{props.msg}</span>
        <div style={{height: "3rem"}}/>
        <Action onClick={props.onClose}>
          Ok
        </Action>
      </div>
    </Modal>
  )
};

export { render_header, PaymentsContainer2, InfoDialog };
